export const comics = [
  {
    id: 1,
    slug: 'dule-jianglin',
    title: '独乐将临',
    author: '李贤民',
    category: '热血',
    rating: 9.8,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20illustration%20of%20an%20intense%20action%20protagonist%20with%20dark%20hair%20and%20sharp%20eyes%2C%20dramatic%20lighting%20from%20behind%2C%20red%20and%20black%20color%20scheme%2C%20martial%20arts%20stance%2C%20clean%20composition%20on%20simple%20warm%20beige%20background%2C%20digital%20art%20style%2C%20high%20contrast%2C%20manhwa%20cover%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20Korean%20manhwa%20banner%20featuring%20an%20epic%20martial%20arts%20battle%20scene%2C%20multiple%20warriors%20in%20dynamic%20poses%2C%20dramatic%20red%20and%20crimson%20energy%20effects%2C%20ancient%20Korean%20palace%20in%20background%2C%20warm%20atmospheric%20lighting%2C%20digital%20illustration%20style%2C%20clean%20composition%20on%20soft%20gradient%20background&width=1600&height=600&seq=comic-banner-01&orientation=landscape',
    description: '在一个被黑暗势力笼罩的世界里，少年李独乐踏上了拯救苍生的道路。他身怀绝世武功，却背负着无法言说的宿命。当黑暗降临，唯有独乐能照亮前方的路。',
    status: '连载中',
    chapters: 156,
    views: '1.2亿',
    tags: ['热血', '武侠', '战斗', '成长'],
    updatedAt: '2026-07-02',
    isHot: true,
  },
  {
    id: 2,
    slug: 'wo-du-ba-liao',
    title: '我读罢了',
    author: '金志勋',
    category: '校园',
    rating: 9.6,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20school%20romance%20cover%2C%20two%20high%20school%20students%20one%20girl%20one%20boy%20standing%20back%20to%20back%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20white%20color%20palette%2C%20gentle%20spring%20lighting%2C%20simple%20clean%20background%2C%20digital%20manhwa%20art%20style%2C%20romantic%20atmosphere&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20Korean%20manhwa%20school%20romance%20scene%2C%20cherry%20blossom%20trees%20lining%20a%20school%20pathway%2C%20students%20walking%20in%20spring%20sunshine%2C%20soft%20warm%20pink%20tones%2C%20nostalgic%20atmosphere%2C%20digital%20illustration%20with%20clean%20composition%2C%20gentle%20gradient%20background&width=1600&height=600&seq=comic-banner-02&orientation=landscape',
    description: '平凡的高中生林小雨意外获得了一本神秘的日记本，每当她写下愿望，第二天就会以意想不到的方式实现。但每一次实现都伴随着新的困惑和冒险。',
    status: '连载中',
    chapters: 89,
    views: '8900万',
    tags: ['校园', '恋爱', '奇幻', '日常'],
    updatedAt: '2026-07-01',
    isHot: true,
  },
  {
    id: 3,
    slug: 'an-ying-lie-ren',
    title: '暗影猎人',
    author: '朴正宇',
    category: '奇幻',
    rating: 9.5,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20dark%20fantasy%20cover%2C%20a%20mysterious%20hunter%20in%20a%20long%20black%20coat%20holding%20a%20glowing%20sword%2C%20shadowy%20figures%20in%20background%2C%20moonlit%20night%20scene%2C%20silver%20and%20dark%20blue%20tones%2C%20clean%20composition%2C%20dramatic%20manhwa%20style%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20dark%20fantasy%20Korean%20manhwa%20scene%2C%20a%20shadowy%20hunter%20standing%20on%20a%20rooftop%20overlooking%20a%20moonlit%20city%2C%20mysterious%20silver%20glowing%20weapons%2C%20dark%20atmospheric%20night%2C%20dramatic%20lighting%2C%20clean%20digital%20illustration%20style&width=1600&height=600&seq=comic-banner-03&orientation=landscape',
    description: '在人类世界与暗影界的夹缝中，有一群被称为"暗影猎人"的存在。他们守护着两个世界的平衡，猎杀那些跨越界限的邪恶生物。',
    status: '连载中',
    chapters: 203,
    views: '2.5亿',
    tags: ['奇幻', '战斗', '暗黑', '冒险'],
    updatedAt: '2026-07-03',
    isHot: true,
  },
  {
    id: 4,
    slug: 'shei-zai-qiao-men',
    title: '谁在敲门',
    author: '崔恩智',
    category: '悬疑',
    rating: 9.7,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20thriller%20cover%2C%20a%20frightened%20woman%20looking%20through%20a%20slightly%20opened%20door%2C%20dark%20corridor%20behind%20her%2C%20mysterious%20shadow%20visible%2C%20suspenseful%20atmosphere%2C%20warm%20dim%20interior%20lighting%2C%20simple%20composition%2C%20digital%20manhwa%20art&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20suspenseful%20Korean%20manhwa%20scene%2C%20a%20dimly%20lit%20apartment%20corridor%20at%20night%2C%20a%20door%20slightly%20ajar%20with%20mysterious%20light%20spilling%20out%2C%20ominous%20shadows%2C%20warm%20but%20eerie%20atmosphere%2C%20clean%20digital%20illustration&width=1600&height=600&seq=comic-banner-04&orientation=landscape',
    description: '独居女孩每晚都会听到敲门声，但门外却空无一人。当她决定追查真相时，发现了一个令人毛骨悚然的秘密——那扇门连接的，是另一个时空。',
    status: '已完结',
    chapters: 72,
    views: '1.5亿',
    tags: ['悬疑', '惊悚', '推理', '都市'],
    updatedAt: '2026-06-15',
    isHot: false,
  },
  {
    id: 5,
    slug: 'xing-chen-da-hai',
    title: '星辰大海',
    author: '尹多熙',
    category: '科幻',
    rating: 9.4,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20sci-fi%20cover%2C%20a%20young%20astronaut%20floating%20in%20space%20surrounded%20by%20stars%20and%20galaxies%2C%20futuristic%20spacesuit%20design%2C%20deep%20cosmic%20blue%20and%20purple%20background%2C%20clean%20composition%2C%20dreamy%20atmosphere%2C%20digital%20art%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20sci-fi%20Korean%20manhwa%20space%20scene%2C%20a%20massive%20spaceship%20approaching%20a%20colorful%20nebula%2C%20stars%20scattered%20across%20the%20cosmos%2C%20futuristic%20aesthetic%2C%20clean%20digital%20illustration%2C%20dreamy%20atmospheric%20lighting&width=1600&height=600&seq=comic-banner-05&orientation=landscape',
    description: '公元2245年，人类文明已经遍布银河系。年轻的星舰驾驶员尹星辰在一次例行探索任务中，发现了一个足以改变人类命运的古老文明遗迹。',
    status: '连载中',
    chapters: 134,
    views: '9600万',
    tags: ['科幻', '冒险', '太空', '机甲'],
    updatedAt: '2026-06-30',
    isHot: true,
  },
  {
    id: 6,
    slug: 'mo-fa-shao-nv-xing-yue',
    title: '魔法少女星月',
    author: '韩秀雅',
    category: '奇幻',
    rating: 9.3,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20magical%20girl%20cover%2C%20a%20young%20girl%20in%20a%20sparkling%20magical%20outfit%20holding%20a%20glowing%20wand%2C%20stardust%20surrounding%20her%2C%20moon%20and%20stars%20in%20background%2C%20soft%20pink%20and%20gold%20colors%2C%20clean%20composition%2C%20whimsical%20atmosphere&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20whimsical%20magical%20girl%20Korean%20manhwa%20scene%2C%20a%20moonlit%20garden%20with%20floating%20magical%20crystals%2C%20sparkling%20stardust%20everywhere%2C%20pastel%20colors%2C%20fantasy%20atmosphere%2C%20clean%20digital%20illustration&width=1600&height=600&seq=comic-banner-06&orientation=landscape',
    description: '普通初中生星月在某天晚上遇见了来自魔法世界的小精灵，从此开启了双重身份的生活——白天是普通学生，夜晚则是守护城市的魔法少女。',
    status: '连载中',
    chapters: 98,
    views: '7200万',
    tags: ['奇幻', '魔法', '校园', '少女'],
    updatedAt: '2026-07-02',
    isHot: false,
  },
  {
    id: 7,
    slug: 'chao-shen-jing-ji',
    title: '超神竞技',
    author: '郑在勋',
    category: '热血',
    rating: 9.2,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20sports%20action%20cover%2C%20a%20determined%20young%20athlete%20in%20dynamic%20running%20pose%2C%20energy%20aura%20surrounding%20him%2C%20stadium%20lights%20in%20background%2C%20warm%20golden%20lighting%2C%20clean%20composition%2C%20intense%20sports%20manhwa%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20epic%20sports%20Korean%20manhwa%20scene%2C%20a%20massive%20stadium%20filled%20with%20fans%2C%20athletes%20competing%20on%20the%20field%2C%20dramatic%20lighting%2C%20golden%20hour%20sunset%2C%20clean%20digital%20illustration%2C%20inspiring%20atmosphere&width=1600&height=600&seq=comic-banner-07&orientation=landscape',
    description: '天赋异禀的少年运动员金泰昊，在超神竞技大赛中一路过关斩将。面对强大的对手和内心的恐惧，他必须超越自己的极限。',
    status: '已完结',
    chapters: 185,
    views: '3.1亿',
    tags: ['热血', '竞技', '运动', '成长'],
    updatedAt: '2026-05-20',
    isHot: false,
  },
  {
    id: 8,
    slug: 'mi-shi-zhi-cheng',
    title: '迷失之城',
    author: '姜瑞元',
    category: '悬疑',
    rating: 9.6,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20mystery%20cover%2C%20a%20detective%20standing%20in%20a%20foggy%20alley%2C%20ancient%20city%20ruins%20visible%20through%20the%20mist%2C%20mysterious%20symbols%20on%20walls%2C%20warm%20amber%20streetlamp%20lighting%2C%20clean%20composition%2C%20atmospheric%20noir%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20mysterious%20Korean%20manhwa%20cityscape%2C%20an%20ancient%20hidden%20city%20emerging%20from%20fog%2C%20mysterious%20architecture%2C%20warm%20sepia%20tones%2C%20explorers%20in%20silhouette%2C%20atmospheric%20lighting%2C%20clean%20digital%20illustration&width=1600&height=600&seq=comic-banner-08&orientation=landscape',
    description: '考古学家姜教授在一次地下挖掘中发现了通往迷失之城的入口。这座传说中的古城隐藏着改变人类历史的秘密，但也潜伏着致命的危险。',
    status: '连载中',
    chapters: 67,
    views: '5800万',
    tags: ['悬疑', '冒险', '考古', '历史'],
    updatedAt: '2026-06-28',
    isHot: true,
  },
  {
    id: 9,
    slug: 'tian-ming-zhi-zi',
    title: '天命之子',
    author: '孙泰英',
    category: '热血',
    rating: 9.1,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20fantasy%20action%20cover%2C%20a%20young%20warrior%20with%20flowing%20dark%20hair%20wielding%20a%20legendary%20sword%2C%20dragon%20spirit%20behind%20him%2C%20ancient%20temple%20background%2C%20golden%20and%20red%20colors%2C%20clean%20composition%2C%20epic%20manhwa%20style&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20epic%20fantasy%20Korean%20manhwa%20scene%2C%20a%20dragon%20soaring%20above%20ancient%20mountains%2C%20warriors%20gathered%20at%20a%20temple%2C%20golden%20sunlight%20breaking%20through%20clouds%2C%20clean%20digital%20illustration%2C%20majestic%20atmosphere&width=1600&height=600&seq=comic-banner-09&orientation=landscape',
    description: '被选为天命之子的少年孙逸尘，继承了上古神龙的意志。在乱世中，他必须集结伙伴，对抗即将苏醒的远古邪神，守护人间的和平。',
    status: '连载中',
    chapters: 210,
    views: '4.2亿',
    tags: ['热血', '武侠', '神龙', '史诗'],
    updatedAt: '2026-07-03',
    isHot: true,
  },
  {
    id: 10,
    slug: 'ni-de-ming-zi',
    title: '你的名字',
    author: '安智慧',
    category: '恋爱',
    rating: 9.9,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20romantic%20drama%20cover%2C%20a%20couple%20standing%20under%20a%20streetlamp%20on%20a%20rainy%20night%2C%20shared%20umbrella%2C%20warm%20golden%20light%20reflecting%20on%20wet%20pavement%2C%20emotional%20atmosphere%2C%20clean%20composition%2C%20beautiful%20manhwa%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20romantic%20Korean%20manhwa%20scene%2C%20a%20couple%20walking%20along%20a%20riverside%20path%20at%20sunset%2C%20cherry%20blossom%20petals%20drifting%2C%20warm%20golden%20hour%20light%2C%20emotional%20romantic%20atmosphere%2C%20clean%20digital%20illustration&width=1600&height=600&seq=comic-banner-10&orientation=landscape',
    description: '两个素不相识的人，因为一次偶然的灵魂互换，开始了彼此生命中最奇妙的旅程。当他们的命运紧紧交织在一起，一段跨越时空的爱恋悄然展开。',
    status: '已完结',
    chapters: 45,
    views: '5.6亿',
    tags: ['恋爱', '奇幻', '治愈', '感人'],
    updatedAt: '2026-04-10',
    isHot: false,
  },
  {
    id: 11,
    slug: 'shen-zhi-ta',
    title: '神之塔',
    author: 'SIU',
    category: '奇幻',
    rating: 9.8,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20fantasy%20adventure%20cover%2C%20a%20boy%20climbing%20a%20massive%20mysterious%20tower%2C%20various%20fantasy%20creatures%20around%20him%2C%20magical%20energy%2C%20warm%20golden%20and%20teal%20colors%2C%20clean%20composition%2C%20epic%20manhwa%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20epic%20fantasy%20tower%20Korean%20manhwa%20scene%2C%20a%20massive%20tower%20reaching%20into%20the%20clouds%2C%20adventurers%20on%20different%20levels%2C%20magical%20portals%2C%20dramatic%20lighting%2C%20clean%20digital%20illustration%2C%20mysterious%20atmosphere&width=1600&height=600&seq=comic-banner-11&orientation=landscape',
    description: '在一个神秘的世界里，矗立着一座通天的巨塔。传说登上塔顶的人可以实现任何愿望。少年第二十五夜为了追寻挚友，毅然踏上了攀登神之塔的旅程。',
    status: '连载中',
    chapters: 550,
    views: '18亿',
    tags: ['奇幻', '冒险', '战斗', '史诗'],
    updatedAt: '2026-07-03',
    isHot: true,
  },
  {
    id: 12,
    slug: 'quan-li-de-you-xi',
    title: '权力的游戏',
    author: '韩石圭',
    category: '悬疑',
    rating: 9.5,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20political%20thriller%20cover%2C%20a%20man%20in%20a%20sharp%20suit%20standing%20in%20a%20modern%20office%2C%20chess%20pieces%20on%20desk%2C%20city%20skyline%20through%20window%2C%20warm%20amber%20interior%20lighting%2C%20clean%20composition%2C%20tense%20drama%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=A%20wide%20corporate%20thriller%20Korean%20manhwa%20scene%2C%20a%20luxurious%20boardroom%20with%20powerful%20figures%2C%20city%20skyline%20at%20dusk%2C%20tense%20atmosphere%2C%20warm%20golden%20lighting%2C%20clean%20digital%20illustration&width=1600&height=600&seq=comic-banner-12&orientation=landscape',
    description: '在大韩民国的政商界，一场关于权力的游戏正在悄然上演。年轻的检察官朴正熙意外卷入了一场惊天阴谋，他必须在正义与生存之间做出选择。',
    status: '已完结',
    chapters: 120,
    views: '2.8亿',
    tags: ['悬疑', '政治', '剧情', '都市'],
    updatedAt: '2026-03-22',
    isHot: false,
  },
];

export const categories = [
  { slug: 'rexue', name: '热血', count: 328, icon: 'ri-fire-line' },
  { slug: 'lianai', name: '恋爱', count: 256, icon: 'ri-heart-line' },
  { slug: 'xuanyi', name: '悬疑', count: 189, icon: 'ri-search-eye-line' },
  { slug: 'qihuan', name: '奇幻', count: 412, icon: 'ri-magic-line' },
  { slug: 'xiaoyuan', name: '校园', count: 145, icon: 'ri-building-line' },
  { slug: 'kehuan', name: '科幻', count: 98, icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖', count: 76, icon: 'ri-ghost-line' },
  { slug: 'gaoxiao', name: '搞笑', count: 203, icon: 'ri-emotion-laugh-line' },
];

export const testimonials = [
  {
    name: '漫画爱好者小明',
    comment: '韩漫网是我用过最好的漫画阅读平台，画质清晰，加载速度快，而且完全免费！每天都会来这里追更新。',
    rating: 5,
  },
  {
    name: '资深漫迷小丽',
    comment: '被朋友推荐来的，一看就停不下来了。下拉式阅读体验太棒了，比翻页式舒服太多了，推荐给所有喜欢韩漫的朋友！',
    rating: 5,
  },
  {
    name: '二次元控阿杰',
    comment: '收藏了韩漫网之后每天都刷，内容更新快，品类齐全，关键是无删减版本，这才是真正的漫画该有的样子。',
    rating: 5,
  },
  {
    name: '上班族小林',
    comment: '通勤路上必刷韩漫网，下拉式设计太适合单手操作了。而且每周都有新作上线，永远不缺漫画看。',
    rating: 4,
  },
];

export const faqs = [
  {
    question: '韩漫网是免费的吗？',
    answer: '是的，韩漫网上所有漫画内容均为免费阅读。我们致力于为广大漫画爱好者提供优质的免费韩漫大全，让每个人都能轻松享受韩国漫画的乐趣。',
  },
  {
    question: '什么是下拉式在线观看？',
    answer: '下拉式在线观看是一种专为手机和电脑优化的漫画阅读方式。您只需向下滑动页面，漫画内容就会自然流畅地展示，无需翻页等待加载，阅读体验更加丝滑。',
  },
  {
    question: '韩漫网的漫画都是无删减版本吗？',
    answer: '是的，韩漫网上的所有漫画内容均为无删减版本。我们坚持提供完整的原作内容，让读者能够体验到漫画家最初想要表达的完整故事。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的热门推荐浏览当前最受欢迎的漫画，或者使用分类页面按类型筛选（热血、恋爱、悬疑、奇幻等）。此外，我们正在开发搜索功能，敬请期待。',
  },
  {
    question: '韩漫网支持离线下载吗？',
    answer: '目前韩漫网为在线阅读平台，暂不支持离线下载功能。但我们的下拉式加载技术确保您在网络良好的情况下获得流畅的阅读体验。',
  },
];